module.exports = __webpack_public_path__ + "static/blankstreet-hero-02e5d2746dc5cadfc5325c98a40ee46b.jpg";